import { render } from "./PokemonOptions.vue?vue&type=template&id=3c9abdf0"
import script from "./PokemonOptions.vue?vue&type=script&lang=js"
export * from "./PokemonOptions.vue?vue&type=script&lang=js"

import "./PokemonOptions.vue?vue&type=style&index=0&id=3c9abdf0&scope=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\programming\\vue\\vue-apuntes\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__